import React from 'react';
import { Panel } from 'react-bootstrap';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';

const List = ({ t, ...rest }) => {
	const columns = [
		{
			header: t('ReportChildren_Parent'),
			accessor: 'fullName',
			sortable: true
		},
		{
			header: t('ReportChildren_Children'),
			accessor: 'childrenCount',
			sortable: false,
			cell: (childrenCount) => (childrenCount === 0 ? (t('ReportChildren_NoChildren')) :
				(childrenCount === 1 ? (t('ReportChildren_OneChild')) : (t('ReportChildren_ManyChildren', { count: childrenCount} ))))
		},
		{
			header: t('ReportChildren_PhoneNumber'),
			accessor: 'phoneNumber',
			sortable: true
		},
		{
			header: t('ReportChildren_Email'),
			accessor: 'email',
			sortable: true
		},
		{
			header: t('ReportChildren_Created'),
			accessor: 'created',
			cell: (created) => (ui.formatDateTime(created)),
			sortable: true
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);